import React from 'react'

import { colors } from 'pixel-base'
import styled from 'styled-components'

import { TruncatedTextWithTooltip } from '../../purchase/details/components/TruncatedTextWithTooltip'

/** One-line product name with ellipsis; full name on hover via PixelTooltip. */
export const InventoryProductNameCell = ({
  name,
}: {
  name?: string | null
}) => <TruncatedTextWithTooltip text={name} />

/** One-line SKU with ellipsis; uses shared inventory grey token. */
export const InventorySkuCell = ({ sku }: { sku?: string | null }) => (
  <SkuCellText title={sku || undefined}>{sku || '--'}</SkuCellText>
)

/** Center numeric/status values when cell value wrappers are width:100%. */
export const CenteredInventoryCellValue = ({
  children,
}: {
  children: React.ReactNode
}) => <CenteredCellValue>{children}</CenteredCellValue>

/**
 * Prevent DataTable horizontal overflow: cells default to flex-shrink:0 and
 * long nowrap content expands the table beyond the viewport.
 */
export const inventoryFitWidthTableStyles = {
  tableWrapper: {
    style: {
      display: 'block',
      width: '100%',
      maxWidth: '100%',
    },
  },
  table: {
    style: {
      width: '100%',
      maxWidth: '100%',
    },
  },
  headCells: {
    style: {
      paddingLeft: '4px',
      paddingRight: '4px',
      overflow: 'hidden',
      flexShrink: 1,
    },
  },
  cells: {
    style: {
      paddingLeft: '4px',
      paddingRight: '4px',
      overflow: 'hidden',
      flexShrink: 1,
      '.rdt_TableCell__value': {
        minWidth: 0,
        width: '100%',
        maxWidth: '100%',
        overflow: 'hidden',
      },
    },
  },
}

const CenteredCellValue = styled.span`
  display: block;
  width: 100%;
  text-align: center;
`

const SkuCellText = styled.span`
  display: block;
  width: 100%;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${colors.grayMedium};
`
